import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Policy.css';

const RefundCancellation = () => {
  return (
    <div className="App">
      <Header />
      <div className="page policy-page">
        <div className="container">
          <div className="policy-header">
            <h1>Refund & Cancellation Policy</h1>
            <p className="policy-updated">Last Updated: January 2025 (Updated for HDFC Bank Smart Gateway Integration)</p>
          </div>

          <div className="policy-content">
            <section className="policy-section">
              <h2>1. Cancellation Policy</h2>
              <div className="policy-text">
                <h3>1.1 Order Cancellation</h3>
                <p>
                  You may cancel your order before it is confirmed or shipped. Once an order is confirmed and payment is processed, 
                  cancellation may be subject to the terms outlined below.
                </p>

                <h3>1.2 Cancellation Timeframe</h3>
                <ul>
                  <li>Orders can be cancelled within 24 hours of placement without any charges</li>
                  <li>After 24 hours, cancellation requests will be reviewed on a case-by-case basis</li>
                  <li>Orders that have already been shipped cannot be cancelled</li>
                </ul>

                <h3>1.3 How to Cancel</h3>
                <p>
                  To cancel an order, please contact us at <a href="mailto:support@slnbooks.com">support@slnbooks.com</a> or call us at 
                  <a href="tel:+919916832476"> +91-9916832476</a> or <a href="tel:+919663622125">+91-9663622125</a> with your order number.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>2. Refund Policy</h2>
              <div className="policy-text">
                <h3>2.1 Refund Eligibility</h3>
                <p>Refunds will be processed in the following cases:</p>
                <ul>
                  <li>Order cancelled within the cancellation timeframe</li>
                  <li>Defective or damaged products received</li>
                  <li>Wrong items delivered</li>
                  <li>Non-delivery of products (after investigation)</li>
                  <li>Duplicate payment for the same order</li>
                </ul>

                <h3>2.2 Non-Refundable Items</h3>
                <ul>
                  <li>Orders cancelled after shipment has been initiated</li>
                  <li>Products damaged due to customer negligence</li>
                  <li>Returned products that are not in original condition</li>
                  <li>Digital products or services already delivered</li>
                </ul>

                <h3>2.3 Refund Process</h3>
                <ol>
                  <li>Submit a refund request via email or phone within 7 days of delivery</li>
                  <li>Our team will review your request within 2-3 business days</li>
                  <li>If approved, refund will be processed to the original payment method through HDFC Bank Smart Gateway</li>
                  <li>Refund amount will be credited to your original payment source within 7-14 business days</li>
                  <li>For card payments, refunds will reflect in your bank statement within 5-7 business days</li>
                  <li>For UPI payments, refunds will be credited to your UPI-linked bank account</li>
                  <li>For Net Banking, refunds will be processed to the same bank account used for payment</li>
                </ol>

                <h3>2.4 Refund Amount</h3>
                <ul>
                  <li>Full refund for cancelled orders (excluding delivery charges if order was shipped)</li>
                  <li>Partial refund may apply for returned items based on condition</li>
                  <li>Delivery charges are non-refundable for orders that were shipped</li>
                </ul>
              </div>
            </section>

            <section className="policy-section">
              <h2>3. Return Policy</h2>
              <div className="policy-text">
                <h3>3.1 Return Conditions</h3>
                <ul>
                  <li>Items must be returned within 7 days of delivery</li>
                  <li>Products must be in original, unopened condition</li>
                  <li>Original packaging and invoice must be included</li>
                  <li>Books must not have any markings, highlights, or damage</li>
                </ul>

                <h3>3.2 Return Process</h3>
                <ol>
                  <li>Contact our customer support team to initiate return</li>
                  <li>Receive return authorization and instructions</li>
                  <li>Pack items securely in original packaging</li>
                  <li>Return items to our address (provided upon request)</li>
                  <li>Refund will be processed after verification</li>
                </ol>

                <h3>3.3 Return Shipping</h3>
                <p>
                  Return shipping costs will be borne by the customer unless the return is due to our error 
                  (wrong item, defective product, etc.).
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>4. Payment Gateway and Refund Processing</h2>
              <div className="policy-text">
                <h3>4.1 Payment Gateway</h3>
                <p>
                  All payments are processed securely through HDFC Bank Smart Gateway. Your payment 
                  information is encrypted and handled in accordance with PCI-DSS security standards. 
                  We do not store your complete card details or payment credentials on our servers.
                </p>

                <h3>4.2 Refund Processing</h3>
                <p>
                  Refunds are processed through the same payment gateway used for the original transaction. 
                  The refund will be credited to the original payment method:
                </p>
                <ul>
                  <li><strong>Credit/Debit Cards:</strong> Refund will be credited to the same card within 5-7 business days</li>
                  <li><strong>UPI:</strong> Refund will be credited to your UPI-linked bank account within 3-5 business days</li>
                  <li><strong>Net Banking:</strong> Refund will be credited to the same bank account within 5-7 business days</li>
                </ul>
                <p>
                  Please note that the refund processing time may vary depending on your bank's processing 
                  time. If you do not receive the refund within the specified timeframe, please contact us 
                  with your transaction details.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>5. Contact for Refunds/Cancellations</h2>
              <div className="policy-text">
                <p>
                  For any queries regarding refunds or cancellations, please contact us:
                </p>
                <ul>
                  <li><strong>Email:</strong> <a href="mailto:support@slnbooks.com">support@slnbooks.com</a></li>
                  <li><strong>Phone:</strong> <a href="tel:+919916832476">+91-9916832476</a>, <a href="tel:+919663622125">+91-9663622125</a></li>
                  <li><strong>Business Hours:</strong> Monday - Friday: 9:00 AM - 6:00 PM, Saturday: 10:00 AM - 4:00 PM</li>
                </ul>
                <p>
                  For payment-related queries, you can also contact HDFC Bank customer support at 
                  <a href="tel:18002586161"> 1800-258-6161</a> or visit 
                  <a href="https://www.hdfcbank.com" target="_blank" rel="noopener noreferrer"> www.hdfcbank.com</a>.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>6. Dispute Resolution</h2>
              <div className="policy-text">
                <p>
                  If you are not satisfied with our refund or cancellation decision, you may escalate the matter 
                  through our grievance redressal mechanism. Please refer to our Grievance Redressal Policy for details.
                </p>
                <p>
                  For payment disputes or unauthorized transactions, please contact HDFC Bank immediately 
                  and also notify us at <a href="mailto:support@slnbooks.com">support@slnbooks.com</a> with 
                  transaction details.
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RefundCancellation;

